document.addEventListener('DOMContentLoaded', () => {
  if (window.__addonAtcRegistered) return;
  window.__addonAtcRegistered = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-drawer-addons .button[data-varid]');
    if (!btn) return;

    e.preventDefault();

    const variantId = btn.dataset.varid;
    if (!variantId) return;

    btn.classList.add('loading');
    btn.disabled = true;

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', ['cart-drawer', 'cart-bubble'].join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
      .then((res) => res.json())
      .then((parsedState) => {
        if (parsedState.status) {
          btn.classList.remove('loading');
          btn.disabled = false;
          return;
        }

        // Re-render cart drawer
        const cartDrawerEl = document.getElementById('Cart-Drawer');
        if (cartDrawerEl && parsedState.sections?.['cart-drawer']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(parsedState.sections['cart-drawer'], 'text/html');
          const newDrawer = doc.querySelector('.cart-drawer');
          if (newDrawer) {
            cartDrawerEl.innerHTML = newDrawer.innerHTML;
          }
        }

        // Re-render cart bubble count
        const cartBubbleEl = document.getElementById('cart-drawer-toggle');
        if (cartBubbleEl && parsedState.sections?.['cart-bubble']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(parsedState.sections['cart-bubble'], 'text/html');
          const newCount = doc.querySelector('.thb-item-count');
          const existingCount = cartBubbleEl.querySelector('.thb-item-count');
          if (newCount && existingCount) {
            existingCount.innerHTML = newCount.innerHTML;
            const q = parseInt(newCount.textContent, 10);
            existingCount.classList.toggle('red-bubble', !isNaN(q) && q > 0);
          }
        }

        // Re-initialize CartDrawer so quantity selectors / remove links work
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }

        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', { product: parsedState });
        }
      })
      .catch(() => {
        btn.classList.remove('loading');
        btn.disabled = false;
      });
  });
});
